import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { Button, TextField } from '@/components/Common';
import { IconPosition } from '@/components/Common/TextField/TextField.types';
import { Modal } from '@/components/Layout';
import iconRank from '@/assets/icons/rank.svg';
import iconFile from '@/assets/icons/file.svg';
import { useAddGiftLogic } from './useAddGiftLogic';

type AddGiftProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const AddGift = ({ isOpen, onClose }: AddGiftProps) => {
  const { register, handleSubmit, errors, examConfigs, onSubmit } =
    useAddGiftLogic(onClose);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalStyle="bg-bgModal"
      headerStyle="bg-bgModal h-[36px]"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="w-[315px]">
          <h1 className="mb-5 text-[20px] font-bold text-center text-white">
            Ajouter un cadeau
          </h1>
          <TextField
            textFieldType={TextfieldType.INPUT}
            icon={<img src={iconRank} alt="rank" />}
            iconPosition={IconPosition.LEFT}
            placeholder="1er Rang"
            name="ranking"
            register={register('ranking')}
            helpText={errors.ranking?.message}
            errorStyle="text-red-500 text-xs"
            className="!text-iconColor font-normal"
            borderStyle="!bg-almostBlack pl-[22px]"
          />
          <TextField
            className="mb-0 placeholder:text-iconColor"
            borderStyle="!bg-almostBlack pl-[22px]"
            name="name"
            placeholder="Nom du cadeau"
            textFieldType={TextfieldType.INPUT}
            iconPosition={IconPosition.LEFT}
            icon={<img src={iconFile} alt="file" />}
            register={register('name')}
            helpText={errors.name?.message}
            errorStyle="text-red-500 text-xs"
          />
        </div>
        <Button
          type="submit"
          title="Ajouter"
          className="w-full mt-10"
          disabled={!examConfigs || examConfigs.length === 0}
        />
      </form>
    </Modal>
  );
};
